module.exports = "<div class=\"card-header\">\n  <p>\n      {{track_app.trackError}} \n  </p>\n</div>\n"